module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }